// Detects IE11
// returns true on IE11
// returns false on Edge and other IEs/browsers.
// eslint-disable-next-line import/prefer-default-export
export const browserIsIE11 =
  !!window.MSInputMethodContext && !!document.documentMode;
